import conductorArt from '../../assets/helper-icons/conductor-art.png';
import forkArt from '../../assets/helper-icons/fork-art.png';
import hallArt from '../../assets/helper-icons/hall-art.png';
import metronomeArt from '../../assets/helper-icons/metronome-art.png';
import principalArt from '../../assets/helper-icons/principal-trumpet-art.png';
import standArt from '../../assets/helper-icons/stand-art.png';
import Styles from './SidebarArt.module.css';

// Same shape as the pixel components in art.jsx: <Art className="..." />
const make = (src) => ({ className = '' }) => (
  <img
    className={`${Styles.icon} ${className}`}
    src={src}
    alt=""
    draggable={false}
    decoding="async"
  />
);

export const MetronomeArt = make(metronomeArt);
export const StandArt = make(standArt);
export const PrincipalTrumpetArt = make(principalArt);
export const ConductorArt = make(conductorArt);
export const HallArt = make(hallArt);
export const ForkArt = make(forkArt);

export const ART = {
  metronome: MetronomeArt,
  stand: StandArt,
  principal: PrincipalTrumpetArt,
  conductor: ConductorArt,
  hall: HallArt,
  fork: ForkArt,
};